import React from 'react'

export const About = () => {
    return (
        <div>
            This is an About Component.
            <p>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Totam, doloremque cumque ducimus, velit similique culpa consectetur placeat maxime nesciunt doloribus, quia corrupti nobis impedit. Soluta ullam velit ad in non et sit quam vel.</p>
        </div>
    )
}
